module.exports = __webpack_public_path__ + "static/media/cartagena-31.468b6da9.jpg";